/*
	GETTERS
*/
//------------------------------------------------------------
//
//------------------------------------------------------------
//------------------------------------------------------------
// GET DIRECTORIES FROM PATH
//
// 1. Takes string path, eg. '/Desktop/My Computer/Drive'
// 2. Deep searches fileSystem state for matching nodes
// 3. Constructs array of nodes, with the last being the active
//------------------------------------------------------------

const getDirectoriesFromPath = (state) => (path) => {

	//===========================================
	// CREATE PATH BREADCRUMBS FROM STRING
	//
	// 'path' argument is: '/Desktop/My Computer/Drive'
	//
	// End result:
	// directoriesArray = [{path: "/"}, {path: "/Desktop"}, {path: "/Desktop/My Computer"}, {path: "/Desktop/My Computer/Drive"}];
	//===========================================

	let directoriesArray = path.split('/').map((value, index, list) => {
		return { path: '/' + list.slice(1, index + 1).join('/') };
	});

	const totalPaths = directoriesArray.length-2;

	//===========================================
	// DEEP NODE SEARCH
	//===========================================

	let count = 0;

	const deepNodeSearch = (node, path) => {

		// console.log(path);

	    const nodeFromPath = node.path === path && node; // node object has property "path"=path

	    // NODE EXISTS
	    if (nodeFromPath) {

	        // Increment counter to get the next path node in directoriesArray, eg. '/Desktop' then 'My Computer' etc.
	        // Store it back on the object to return later.
	        directoriesArray[count].node = nodeFromPath;

	        nodeFromPath.open = true; // should this be here? changing state ?????????

	        // If the final directory has not been reached
	        // AND the current node has children array to search...

	        const children = nodeFromPath.children;

	        if (count <= totalPaths && children.length) {

		        count++;

	            for (let i = 0; i < children.length; i++) {
	                deepNodeSearch(children[i], directoriesArray[count].path);
	            }
		    }

		    // all done - here's the final directory breadcrumb array
		    return directoriesArray;
	    }

	    // no node exists, keep rolling through
	    // console.warn(node.path + " didn't match, skipping.");
	    return false;
	}

	//===========================================
	// START HERE
	//===========================================

	return deepNodeSearch(state.local, '/'); // directoriesArray[count].path
}



/*
https://gist.github.com/flipace/bed6b89aed5cb0e19cde

JSON.parse(JSON.stringify(object), (key, value) => {
if (key=='propToChange') {
return newValue;
} else {
return value;
}
})
*/

//------------------------------------------------------------
// EXPORT
//------------------------------------------------------------

export default {
	getDirectoriesFromPath
}
//===========================================
//
//===========================================